import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { applyScopeRoleGrants } from "../rbac/applyScopeRoleGrants";
import { fetchGrantResources } from "../rbac/grantResources";
import { SCOPE_MANAGE_GRANTS_PERMISSION } from "../rbac/roles";
import { mutator } from "./mutator";

export const approveGrantRequest = mutator({
  schema: z.object({ requestId: z.string() }),
  resolve: {
    request: { kind: "grantRequest", from: "requestId" },
  },
  permissions: [
    {
      permission: ({ args }) =>
        SCOPE_MANAGE_GRANTS_PERMISSION[args.request.scopeKind],
      scopeId: ({ args }) => args.request.scopeId,
    },
  ],
  fn: async ({ tx, ctx, args: { request } }) => {
    const grantRows = await tx.run(
      zql.grantRequestGrants.where("requestId", request.id)
    );
    const grants = grantRows.map((g) => ({
      userGroupId: g.userGroupId ?? undefined,
      userId: g.userId ?? undefined,
      serviceAccountId: g.serviceAccountId ?? undefined,
      builtinRoleId: g.builtinRoleId ?? undefined,
      customRoleId: g.customRoleId ?? undefined,
    }));
    const resources = await fetchGrantResources(tx, grants, ctx.tenantId);
    await applyScopeRoleGrants({
      tx,
      ctx,
      scopeId: request.scopeId,
      scopeKind: request.scopeKind,
      grants,
      customRoles: resources.grantCustomRoles,
    });

    await tx.mutate.grantRequests.delete({ id: request.id });
  },
});
